import { IconButton } from "@mui/material";
import { FunctionComponent, PropsWithChildren, ReactNode } from "react";
import cn from "classnames";
import { MagicSpinner } from "react-spinners-kit";
import Image from "next/image";

interface Prop {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  disabled?: boolean;
  size?: "sm" | "lg";
  type?: "contained" | "soft" | "outlined" | "text" | "onDark" | "darkoutlined";
  icon?: ReactNode;
  iconImg?: string;
  roundedFull?: boolean;
}

const DarkIconButton: FunctionComponent<PropsWithChildren<Prop>> = (props) => {
  const style: ButtonStyle = getStyle(props.type ?? "contained");
  return (
    <IconButton
      id="darkiconbtn"
      type="submit"
      onClick={props.disabled === true ? () => {} : props.onClick}
      disabled={props.disabled}
      classes={{ disabled: style.disabled }}
      className={cn(
        props.roundedFull === true ? "rounded-full" : "rounded-xl",
        props.size === "sm" ? "w-10 h-10" : "w-12 h-12",
        style.main
      )}
    >
      {props.loading === true ? (
        <MagicSpinner size={30} color={style.loader} loading />
      ) : (
        <div className="flex items-center justify-center">
          {props.icon === undefined ? (
            <Image
              draggable={false}
              width={30}
              height={30}
              alt="img"
              src={props.iconImg ?? ""}
              className={props.size === "sm" ? "w-5 h-5" : "w-[22px], h-[22px]"}
            />
          ) : (
            props.icon
          )}
        </div>
      )}
    </IconButton>
  );
};
interface ButtonStyle {
  disabled: string;
  main: string;
  loader: string;
}
const getStyle = (type: string): ButtonStyle => {
  switch (type) {
    case "soft":
      return {
        main: "normal-case bg-surfaceMid hover:bg-[#EDEDED] active:bg-secondarySoftMain focus:bg-secondarySoftMain text-textHigh",
        disabled: "bg-[#231F1F]/10 text-[#B0B0B0]",
        loader: "#1F1F1F",
      };
    case "outlined":
      return {
        main: "normal-case border border-solid border-[#E5E5E5] bg-surfaceInverse hover:bg-[#EDEDED] active:bg-secondarySoftMain hover:text-black focus:bg-[#FDB5D6D6D6B5] text-textHigh",
        disabled: "border-[#E5E5E5] bg-surfaceInverse text-[#B0B0B0]",
        loader: "#B0B0B0",
      };
    case "darkoutlined":
      return {
        main: "normal-case border border-solid border-[#525252] hover:bg-[#EDEDED] active:bg-secondarySoftMain focus:bg-[#FDB5D6D6D6B5] text-textHigh",
        disabled: "border-[#E5E5E5] bg-surfaceInverse text-[#B0B0B0]",
        loader: "#B0B0B0",
      };
    case "text":
      return {
        main: "normal-case bg-transparent hover:bg-secondarySoftMain active:bg-secondarySoftMain focus:bg-secondarySoftMain text-textHigh",
        disabled: "bg-transparent text-[#B0B0B0]",
        loader: "#B0B0B0",
      };
    case "onDark":
      return {
        main: "normal-case bg-white/10 hover:bg-white/10 active:bg-white/10 focus:bg-white/10 text-textInverse",
        disabled: "bg-transparent text-[#B0B0B0]",
        loader: "#B0B0B0",
      };
    default:
      return {
        main: "normal-case bg-secondaryMain hover:bg-[#1F1F1F] active:bg-[#1F1F1F] focus:bg-[#1F1F1F] text-surfaceWebGrey",
        disabled: "bg-[#231F1F]/10 text-[#B0B0B0]",
        loader: "#B0B0B0",
      };
  }
};

export default DarkIconButton;
